import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AgTimeAgoPipe} from './ag-time-ago.pipe';

@NgModule({
  declarations: [AgTimeAgoPipe],
  imports: [CommonModule],
  exports: [AgTimeAgoPipe]
})
export class AgTimeAgoModule {
}
